import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("ControleIntegracaoGRPDetalheTO")
export class ControleIntegracaoGRPDetalheTO {
  enviado: string;
  recebido: string;
}
